import React, {useState, useEffect} from "react";
import {Form, Container, Card} from "react-bootstrap";
import "./LaborerMaster.css";
import axios from "../../util/Axios/AxiosInstance";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import * as ReactBootStrap from "react-bootstrap";
import filterFactory, {textFilter} from "react-bootstrap-table2-filter";
import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";
import ToolkitProvider, {
    CSVExport,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import edit from "../../../images/edit.png";
import TableActionIcon from "../../util/TableActionIcon";
import AOS from "aos";
import "aos/dist/aos.css";
import Skeleton from "react-loading-skeleton";
import {formatIdentifier} from "./formatIdentifiers";

function LabourMasterDataTable({HandleEvent, HandleEventGetId}) {
    const [tableData, setTableData] = useState([
        {labourName: <Skeleton/>, contractName: <Skeleton/>, vendorName: <Skeleton/>},
        {labourName: <Skeleton/>, contractName: <Skeleton/>, vendorName: <Skeleton/>},
        {labourName: <Skeleton/>, contractName: <Skeleton/>, vendorName: <Skeleton/>},
        {labourName: <Skeleton/>, contractName: <Skeleton/>, vendorName: <Skeleton/>},
        {labourName: <Skeleton/>, contractName: <Skeleton/>, vendorName: <Skeleton/>},
        {labourName: <Skeleton/>, contractName: <Skeleton/>, vendorName: <Skeleton/>},
    ]);
    const [loading, setLoading] = useState(false);
    const [vendorAccount, setVendorAccount] = useState(false);
    const [role, setRole] = useState("");
    const [pageNumber, setPageNumber] = useState(1);
    const [pageSize, setPageSize] = useState(10);

    let [formatDate, setFormatDate] = useState('');

    const { ExportCSVButton } = CSVExport;

    const getLaborMasterDatabyBranchIdVendorId = async (branchId, vendorId) => {
        try {
            const data = await axios.get(
                "getMasterLabourerDetailsByBranchAndVendorId/" +
                branchId +
                "/" +
                vendorId
            );
            setTableData(data.data);

            setLoading(true);
        } catch (error) {
            console.log(error);
        }
    };

    const getLaborMasterDataByBranchId = async (branchId) => {
        try {
            const data = await axios.get(
                "getMasterLabourerDetailsByBranchId/" + branchId
            );
            setTableData(data.data);

            setLoading(true);
        } catch (e) {
            console.log(e.response.status);
        }
    };

    //  useEffect(() => {
    //   getLaborMasterData();
    //  }, []);

    useEffect(() => {
        AOS.init();
        const userrole = localStorage.getItem("role");

        setRole(userrole);
        const branchId = localStorage.getItem("branchId");
        switch (role) {
            case "Vendor":
                const vid = localStorage.getItem("vendorId");

                getLaborMasterDatabyBranchIdVendorId(branchId, vid);
                setVendorAccount(true);
                break;
            case "Admin":
                getLaborMasterDataByBranchId(branchId);
                setVendorAccount(true)
                break;
            case "SuperAdmin":
                getLaborMasterDataByBranchId(branchId);
                setVendorAccount(true)
                break;
            case "Security":
                getLaborMasterDataByBranchId(branchId);
                setVendorAccount(true)
                break;
        }
    }, [role]);

    //  const selectRow = {
    //   // mode: 'button',
    //   clickToSelect: true,
    //   selectColumnPosition: 'right',
    //   onSelect: (row, isSelect, rowIndex, e) => {
    //
    //
    //
    //
    //     HandleEventGetId(10,row)
    //   }
    // };

    // const editData = (row) =>{
    // HandleEventGetId(10,row)
    // };

    const updateStatus = (row) => {
        if (row.status) {
            row.status = 0;
        } else {
            row.status = 1;
        }

        axios.put("updateLabourerMasterDetails/" + row.id, row)
            .then((data) => {

            })
            .catch((err) => {
                console.log(err)
            })
    };

    const options = {
        onSizePerPageChange: (sizePerPage, page) => {
            setPageSize(sizePerPage);
            // setPageNumber(page);
        },
        onPageChange: (page, sizePerPage) => {
            // setPageSize(sizePerPage);
            setPageNumber(page);
        },
    };

    function doSomething() {

    }

    const columns = [
        {
            dataField: "id",
            text: "S No.",
            formatter: (cell, row, rowIndex) => {
                //
                //
                //
                return (pageNumber - 1) * pageSize + (rowIndex + 1);
            },
            csvFormatter: (cell, row, rowIndex) => {
                return (rowIndex + 1); // 👈 this controls export value
            },
            headerStyle: (colum, colIndex) => {
                return {width: "60px", textAlign: "center"};
            },
        },
        { dataField: "labourId",
            text: "Labour ID",
            sort: true,
            filter: textFilter(),
            title: (cell, row, rowIndex, colIndex) => `${cell}`,},
        {
            dataField: "labourName",
            text: "Labour Name",
            sort: true,
            filter: textFilter(),
            title: (cell, row, rowIndex, colIndex) => `${cell}`,
        },
        {
            dataField: "contractName",
            text: "Contract Name",
            sort: true,
            filter: textFilter(),
            title: (cell, row, rowIndex, colIndex) => `${cell}`,
        },
        {
            dataField: "vendorName",
            text: "Vendor Name",
            sort: true,
            filter: textFilter(),
            title: (cell, row, rowIndex, colIndex) => `${cell}`,
        },
        { dataField: "adhaarNo", text: "Aadhaar No.",
            sort: true,
            filter: textFilter(),
            formatter: (cell) => formatIdentifier(cell),
            csvFormatter: (cell) => formatIdentifier(cell),
            title: (cell) => formatIdentifier(cell),
        },
        { dataField: "uanNo", text: "UAN No.",
            sort: true,
            filter: textFilter(),
            formatter: (cell) => formatIdentifier(cell),
            csvFormatter: (cell) => formatIdentifier(cell),
            title: (cell) => formatIdentifier(cell),
        },
        { dataField: "esiNo", text: "ESI No.",
            sort: true,
            filter: textFilter(),
            formatter: (cell) => formatIdentifier(cell),
            csvFormatter: (cell) => formatIdentifier(cell),
            title: (cell) => formatIdentifier(cell),
        },
        // { dataField: "manpower", text: "Manpower" },
        // { dataField: "branchName", text: "Branch Name" },
        // { dataField: "ifscCode", text: "Ifsc Code" },
        {
            dataField: "status",
            text: "Status",
            hidden: !vendorAccount,
            formatter: (cellContent, row) => {
                return (
                    <Form.Check
                        type="switch"
                        id="custom-switch"
                        defaultChecked={cellContent}
                        onClick={() => {
                            (loading === true)
                                ? updateStatus(row)
                                : doSomething();

                        }}
                    ></Form.Check>
                );
            },
            title: (cell, row, rowIndex, colIndex) => `${cell}`,
        },
        {
            dataField: "labourDob",
            text: "Edit",
            isDummyField: true,
            csvExport: false,
            hidden: !vendorAccount,
            formatter: (cellContent, row) => {
                return (
                    <TableActionIcon
                        src={edit}
                        title="Edit labour"
                        disabled={!loading}
                        onClick={() => HandleEventGetId(10, row)}
                    />
                );
            },
        },
    ];

    useEffect(() => {
        AOS.init();
        let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        let date = new Date();

        const format = months[date.getMonth()] + date.getDate() + ',' + date.getFullYear();
        setFormatDate(format);
    }, [])

    return (
        <Card className="cardStyl">
            <Container fluid className="px-0">
                <div className={"mt-2"}>
                    {/*<h2>Laborer Master</h2>*/}
                    <h5 className={"priColor"}>Labour List</h5>
                </div>
                <div>
                    <div className={"row"}>
                        <div style={{marginBottom: "10px"}}>

                        </div>
                    </div>
                    <div data-aos="zoom-in-right" data-aos-duration="550">
                        <ToolkitProvider
                            keyField="id"
                            data={tableData}
                            columns={columns}
                            exportCSV={{
                                fileName: "Labour_List" + '  ' + formatDate + ".csv",
                                onlyExportFiltered: true, // optional
                                exportAll: false // change to true if you want all data
                            }}
                        >
                            {(props) => (
                                <>
                                    <div className="d-flex justify-content-end mb-2">
                                        {vendorAccount ? (
                                            <button
                                                className={"btn btn-primary me-2"}
                                                variant="primary"
                                                style={{float: "right"}}
                                                onClick={(e) => HandleEvent(9)}
                                            >
                                                Add Labour
                                            </button>
                                        ) : (
                                            ""
                                        )}
                                        <ExportCSVButton
                                            {...props.csvProps}
                                            className="btn btn-success"
                                        >
                                            Export CSV
                                        </ExportCSVButton>
                                    </div>

                                    <BootstrapTable
                                        {...props.baseProps}
                                        bootstrap4
                                        wrapperClasses="table-responsive"
                                        pagination={paginationFactory(options)}
                                        filter={filterFactory()}
                                    />
                                </>
                            )}
                        </ToolkitProvider>
                    </div>
                </div>
            </Container>
        </Card>
    );
}

export default LabourMasterDataTable;
